import Recipient                    from 'scripts/defa/recipients/model-recipient';
import Recipients                   from 'scripts/defa/recipients/collection-recipients';
import RecipientGroup               from 'scripts/defa/recipients/model-recipientGroup';
import RecipientGroups              from 'scripts/defa/recipients/collection-recipientGroups';
import RecipientGroupHolder         from 'scripts/defa/recipients/model-recipientGroup-holder';
import RecipientGroupHolders        from 'scripts/defa/recipients/collection-recipientGroup-holders';
import RecipientSnippet             from 'scripts/defa/recipients/view-recipient-snippet'
import RecipientCollectionView      from 'scripts/defa/recipients/view-recipient-collection-view';
import RecipientEmailCreateForm     from 'scripts/defa/recipients/view-recipient-email-create-form'
import RecipientGroupCollectionView from 'scripts/defa/recipients/view-recipient-groups-collection-view';
import RecipientPhoneCreateForm     from 'scripts/defa/recipients/view-recipient-phone-create-form';
import RecipientsContainerView      from 'scripts/defa/recipients/view-recipients-container';
import RecipientGroupSnippet        from 'scripts/defa/recipients/view-recipient-group-snippet';
import RecipientGroupCreateForm     from 'scripts/defa/recipients/view-recipient-group-create-form'
import RecipientGroupDeleteForm     from 'scripts/defa/recipients/view-recipientGroup-delete-form'
import RecipientGroupUpdateForm     from 'scripts/defa/recipients/view-recipient-group-update-form';
import RecipientRouter              from 'scripts/defa/recipients/router-recipient-router';
import RecipientController          from 'scripts/defa/recipients/controller-recipient-controller';

import Module                           from 'scripts/module';

const RecipientsModule = new Module('RecipientsModule',{
	collections: {
		Recipients,
		RecipientGroups,
		RecipientGroupHolders
	},
	controllers: {
		RecipientController
	},
	models     : {
		RecipientGroup,
		RecipientGroupHolder,
		Recipient,
	},
	routers    : {
		RecipientRouter
	},
	views      : {
		RecipientSnippet,
		RecipientCollectionView,
		RecipientEmailCreateForm,
		RecipientPhoneCreateForm,
		RecipientGroupCollectionView,
		RecipientsContainerView,
		RecipientGroupSnippet,
		RecipientGroupCreateForm,
		RecipientGroupDeleteForm,
		RecipientGroupUpdateForm
	}
});
export default RecipientsModule;